import { render, staticRenderFns } from "./Previewable_File_Item.vue?vue&type=template&id=281cbe3b&"
import script from "./Previewable_File_Item.vue?vue&type=script&lang=js&"
export * from "./Previewable_File_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports